import React, { Component } from 'react';

import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import { connect } from 'react-redux';
import { openDrawer, closeDrawer } from 'actions/drawer';
import { openModal } from 'actions/modal';

import { firebaseConnect, helpers } from 'react-redux-firebase';
const { isLoaded, dataToJS, pathToJS } = helpers;
import { VisibleOnlyAdmin, VisibleOnlyCustomer } from 'components/AuthenticatedComponent';
import Input from 'components/Input';

import { keyedObjToArr, encrypt } from '../../util';

import ContentHeader from 'components/ContentHeader';
import Button from 'components/Button';
import UserPanel from 'components/UserPanel';
import UserList from 'components/UserList';
import Loader from 'components/Loader/Loader';
import Footer from 'components/AppFooter/AppFooter';

let axios = require('axios');

class Users extends Component {

	constructor (props) {
		super(props);

		this.state = {
			user : {},
			filterBy: ''
		};
	}

	createUser () {
		this.props.openDrawer(<UserPanel
			editing={false}
			addUser={this.addUser.bind(this)}
		/>);
	}

	addUser (user) {
        const { firebase } = this.props;
        if(user.email && user.password) {
            firebase.auth().currentUser.getToken(true).then(function(idToken){
                let baseUrl = BASE_API_URL;
                if(!baseUrl){
                    baseUrl = 'https://us-central1-colvard-master-database.cloudfunctions.net';
                }
                let url = baseUrl + '/api/createUser';
                axios({
                    method:'post',
                    url: url,
                    headers:{
                        'content-type': 'application/json',
                        'authorization': 'Bearer ' + idToken
                    },
                    data: {
                        email:user.email,
                        password: encrypt(user.password),
                        name: user.name,
                        role: user.role,
                        customer: user.role === 'admin' ? '' : user.customer,
                        trial: user.trial,
                        trialEndDate: user.trialEndDate ? user.trialEndDate : ''
                    }
                }).then(function (response) {
                    return true;
                }).catch(function (error) {
                    return false;
                });
            });
		}
		return true;
	}

	saveUser (user) {
		//Return if not admin on all of these

		const { firebase } = this.props;
		firebase.set(`users/${user.id}`, user).then( (response)=> {
			if(user.customer) {
				let customerUserIds = this.props.customers[user.customer].users || {};
				customerUserIds[user.id] = true;
				firebase.set(`customers/${user.customer}/users`,customerUserIds);
			}
		});
	}

	editUser (user) {
		this.props.openDrawer(<UserPanel
			user={user}
			editing={true}
			saveUser={this.saveUser.bind(this)}
		/>);
	}

	deleteUser (user) {
		this.props.openModal(null, {
			message : `Are you sure you want to delete ${user.name}?`,
			title : 'Delete User',
			onClose : (result) => {
                if(result) {
                    const {firebase} = this.props;
                    // Remove the user from the customer, and the customer from the user
                    if(user.customer) {
                        firebase.remove(`/customers/${user.customer}/users/${user.id}`);
                    }
                    firebase.remove(`/users/${user.id}/customer`);

                    // Remove the user from their classrooms and the classrooms from the user
                    keyedObjToArr(user.classrooms).forEach((classroom) => {
                        // We need to
                        firebase.remove(`/classrooms/${classroom.id}/teacher`);
                    });
                    firebase.remove(`/users/${user.id}/classrooms`);
                    firebase.remove(`/users/${user.id}/current_classrooms`);

                    // Disabled the user
                    firebase.set(`/users/${user.id}/disabled`, true);

                    firebase.auth().currentUser.getToken(true).then(function(idToken){
                        let baseUrl = BASE_API_URL;
                        if(!baseUrl){
                            baseUrl = 'https://us-central1-colvard-master-database.cloudfunctions.net';
                        }
                        let url = baseUrl + '/api/deleteUser';
                        axios({
                            method:'post',
                            url: url,
                            headers:{
                                'content-type': 'application/json',
                                'authorization': 'Bearer ' + idToken
                            },
                            data: {
                                uid:user.id
                            }
                        }).then(function (response) {
                            console.log(response);
                        }).catch(function (error) {
                            console.log(error);
                        });
                    });
				}
			}
		});
	}

    filterChanged(event){
        this.setState({
            filterBy: event.target.value
        });
    }

	render () {
		if(!isLoaded(this.props.users) || !isLoaded(this.props.customers)) {
			return (
				<div className="main-content-area">
					<div className="page-content">
						<Loader color="main" size="large" />
					</div>
				</div>
			);
		}

		let button = (<VisibleOnlyAdmin><Button
			label="Create User"
			onClick={this.createUser.bind(this)}
		/></VisibleOnlyAdmin>);

		const { users } = this.props;

        let filter = (<Input
			placeholder="Search"
			inputClass="filter-box"
			value={this.state.filterBy}
			onChange={this.filterChanged.bind(this)}
		/>)

		return (
			<ReactCSSTransitionGroup
				transitionName="main-content"
				transitionAppear={true}
				transitionAppearTimeout={1500}
				transitionEnterTimeout={1500}
				transitionLeaveTimeout={1500}
				className="main-transition-wrap"
			>
			<div className="main-content-area">
				<ContentHeader
					title="Users"
					filter={filter}
                    button={button}
				/>
				<div className="page-content">
					<div className="container">
						<div className="row">
							<div className="col-12">
								<div className="main-list-area">
									<UserList
										filterBy={this.state.filterBy}
										users={this.props.users}
										user={this.props.user}
										customers={this.props.customers}
										editUser={this.editUser.bind(this)}
										deleteUser={this.deleteUser.bind(this)}
									/>
								</div>
							</div>
						</div>
					</div>
					<Footer/>
				</div>
			</div>
			</ReactCSSTransitionGroup>
		);
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		openDrawer :  (panel) => { dispatch(openDrawer(panel)); },
		closeDrawer : () => { dispatch(closeDrawer()); },
		openModal : (modal, props) => { dispatch(openModal(modal, props)); }
	};
};

const mapStateToProps = (state) => {
	return { user : state.user };
};

// REDUX
const fbWrappedComponent = firebaseConnect( ({auth, profile, user}) => {

	if(!profile){
		return [];
	}
	if(profile.role === 'admin') {
		return [
			'/users',
			'/customers'
		];
	} else if(profile.customer) {
		return	[
			{
				path: 'users',
				storeAs: 'users',
				queryParams: [ `orderByChild=customer`, `equalTo=${profile.customer}`]
			},
			{
				path: 'customers/'+profile.customer,
				storeAs: 'customers'
			}
		];
	} else {
		return [];
	}

})(Users);

//Store
const connectStore = connect(
	mapStateToProps)(fbWrappedComponent);

//Auth
const connectAuth = connect(
	({ firebase }) => {
		return{
			profile: pathToJS(firebase, 'profile'),
			authError: pathToJS(firebase, 'authError'),
			auth : pathToJS(firebase, 'auth')
		};

	}
)(connectStore);

//Export
export default connect(
	({ firebase }) => ({
		customers : dataToJS(firebase, '/customers'),
		users: dataToJS(firebase, '/users'),
	}),
	mapDispatchToProps
)(connectAuth);



// WEBPACK FOOTER //
// ./js/containers/Users/Users.js